import { useState } from 'react';
import { getInsufficientStorageQuotaModalChoice } from '@/helpers/media-upload-quota.helper.ts';
import { usePermissionsQuery } from '@/state/queries/permissions/use-permissions.ts';

export function useMediaUploadQuotaModals(eventId: string | undefined) {
  const [isAddStorageModalOpen, setIsAddStorageModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const { data: permissions } = usePermissionsQuery();

  const canPurchaseFromPermissions = !!eventId && !!permissions?.events?.[eventId]?.includes('create_order');

  const handleUploadError = (error: unknown, canPurchaseFromPreflight?: boolean) => {
    const choice = getInsufficientStorageQuotaModalChoice(error, canPurchaseFromPermissions, canPurchaseFromPreflight);
    if (!choice) {
      return false;
    }
    if (choice === 'purchase') {
      setIsAddStorageModalOpen(true);
    } else {
      setIsContactModalOpen(true);
    }
    return true;
  };

  return {
    isAddStorageModalOpen,
    setIsAddStorageModalOpen,
    isContactModalOpen,
    setIsContactModalOpen,
    handleUploadError,
  };
}
